import React, { CSSProperties } from 'react';
import { BackgroundImageDiv } from './Styles';
import { background } from '../../assets/Base64Image';

const BackgroundImage = React.forwardRef<any, Props>((({
  children,
  backgroundImg = background,
  height,
  position,
  size,
  style,
}, ref) => {
  return (
    <BackgroundImageDiv ref={ref} background={backgroundImg} position={position} size={size} height={height} style={style}>
      {children}
    </BackgroundImageDiv>
  );
}));

export interface Props {
  children?: React.ReactNode;
  backgroundImg?: string;
  height?: string;
  position?: string;
  size?: string;
  style?: CSSProperties;
}

export default BackgroundImage;
